import { graphql } from 'relay-runtime';

export const getStandardBySites = graphql`
  query ReportHubGetStandardsBySitesQuery($sitesFilter: SitesFilterInput) {
    sites(sitesFilterInput: $sitesFilter) {
      nodes {
        id
        name
        standardState {
          id
          stateStandardName
        }
      }
    }
  }
`;

export const getTotalDiagnosicAssessmentHistory = graphql`
  query ReportHubDiagnosticAssessmentTotalQuery($filter: AllSkillsFilterInput!) {
    allSkills(filter: $filter) {
      totalCount
    }
  }
`;

export const getTotalSkillAssessmentHistory = graphql`
  query ReportHubSkillAssessmentsTotalQuery($filter: StudentsSkillAssessmentsFilterInput!) {
    studentsSkillAssessments(filter: $filter) {
      totalCount
    }
  }
`;

export const getTotalOutstandingAssessments = graphql`
  query ReportHubOutstandingAssessmentsTotalQuery($filter: AllStudentsFilterInput!) {
    allStudents(filter: $filter) {
      totalCount
    }
  }
`;

export const getDetailedSkillReportByStandardColumns = graphql`
  query ReportHubDetailedSkillReportByStandardsColumnsQuery(
    $classIds: [ID!]!
    $standardStateId: ID!
    $targetGroupId: ID!
    $skip: Boolean = true
  ) {
    skillProgressReportGroupedByStandardsInBytes(
      classIds: $classIds
      standardStateId: $standardStateId
      targetGroupId: $targetGroupId
    ) @skip(if: $skip) {
      data
    }
  }
`;

export const getDetailedSkillReportByStandardRows = graphql`
  query ReportHubDetailedSkillReportByStandardsRowsQuery(
    $classIds: [ID!]!
    $standardStateId: ID!
    $targetGroupId: ID!
    $skip: Boolean = true
  ) {
    transposedSkillProgressReportGroupedByStandardsInBytes(
      classIds: $classIds
      standardStateId: $standardStateId
      targetGroupId: $targetGroupId
    ) @skip(if: $skip) {
      data
    }
  }
`;

export const getDetailedSkillReportByUnitsColumns = graphql`
  query ReportHubDetailedSkillReportByUnitsColumnsQuery(
    $classIds: [ID!]!
    $targetGroupId: ID!
    $standardStateId: ID!
    $skip: Boolean = true
  ) {
    skillProgressReportGroupedByUnitsInBytes(
      classIds: $classIds
      targetGroupId: $targetGroupId
      standardStateId: $standardStateId
    ) @skip(if: $skip) {
      data
    }
  }
`;

export const getDetailedSkillReportByUnitsRows = graphql`
  query ReportHubDetailedSkillReportByUnitsRowsQuery(
    $classIds: [ID!]!
    $targetGroupId: ID!
    $standardStateId: ID!
    $skip: Boolean = true
  ) {
    transposedSkillProgressReportGroupedByUnitsInBytes(
      classIds: $classIds
      targetGroupId: $targetGroupId
      standardStateId: $standardStateId
    ) @skip(if: $skip) {
      data
    }
  }
`;

export const getViewExamplePresignedUrl = graphql`
  query ReportHubViewExamplePresignedUrlQuery($filter: PresignedUrlsForReportExamplesFilterInput!) {
    presignedURLsForReportExamples(filter: $filter) {
      unfinishedDiagnosticsReportExampleUrl
      skillAssessmentHistoryReportExampleUrl
      diagnosticSummaryReportExampleUrl
      detailedSkillReportExampleUrl
    }
  }
`;
